import gql from 'graphql-tag';

export default gql`
	mutation OtpGeneratePhone($phone: ID!) {
		otpGeneratePhone(phone: $phone) {
			ref
		}
	}
`;
